//
export default class Headers extends Array {
    
    /**
     * 
     * @param {*} name 
     * @param  {...any} items 
     */
    constructor(name, ...items) {

        //
        super(...items)

        //
        this.name = name
    }

    /**
     * 
     */
    everyIsNotValue = values => item => values.every(this.isNotValue(item.value))

    /**
     * 
     */
    isNotValue = value => item => item !== value

    /**
     * 
     */
    exclude(values = []) {
        return this.slice().filter(this.everyIsNotValue(values))
    }
}
